import * as constants from './constants'
import Component from './lifestyle.component'
import Container from './lifestyle.container'
import * as utils from './utils'

export { Component, constants, utils }
export default Container
